import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61fd6346"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Whitlam was of the fortunate few to experience tertiary education. His university years were an opening to a world of new opportunities, yet fraught with enduring threats of war. ")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  id: "main",
  class: "mb-lg-40"
}, " Higher Education ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Gough Whitlam undertook a Bachelor of Arts (majoring in Classics), and later a Bachelor of Laws, at the University of Sydney on a scholarship, owing to his outstanding grades in school.", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "The University of Sydney was an Australian transplant of the elite British Cambridge and Oxford universities. Whitlam lived on campus at the all-boys Anglican St Paul’s College. The experience mirrored the traditional, regimented culture of his Canberra Grammar School.", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, " Whitlam kept his creative spirit alive by editing the college magazine and university journals and joining the debating society. Although he generally kept his socialist agenda to himself at the conservative college, he managed to secretly introduce more socialist literature to the library in his time working there. ", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" “Education is the key to equality of opportunity.” ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Gough Whitlam ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "When Whitlam attended university in 1935 there were limited opportunities for students to access higher education. He was one of only 15,000 university students, in just six universities, across the entire country. ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "In response to the potentially damaging socio-economic consequences of the war, the Chifley Government offered free university education and student living allowances to returned military personnel. This policy created greater accessibility for young Australians, and by 1948, university attendance had soared to 32,000 (more than double the pre-war level). "),
  /*#__PURE__*/_createElementVNode("li", null, "The national educational suspension and resulting free education policy convinced Whitlam of the importance of equitable access to tertiary education. As prime minister, he daringly abolished all fees at universities and technical colleges and made tertiary education a federal responsibility. ")
], -1))
const _hoisted_10 = { class: "bg-white zindex-4 position-relative" }
const _hoisted_11 = { class: "container redline py-lg-56" }
const _hoisted_12 = { class: "row py-lg-5" }
const _hoisted_13 = { class: "timelinedot col-12 col-lg-6 col-xl-5 offset-xl-2 col-xxl-4 offset-xxl-4 zindex-2 bg-white" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "1 September 1939", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "light lines-2" }, " Germany invades Poland, igniting the Second World War. ", -1))
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "timelinedot col-12 col-lg-5 col-xl-4 offset-lg-1 offset-xl-3 offset-xxl-4 zindex-2 bg-white" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "1 October 1939", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "light lines-2" }, " At 23 years old, Whitlam joins the Sydney University Regiment of the Army. ", -1))
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "timelinedot col-12 col-lg-5 col-xl-4 offset-lg-7 offset-xl-8 zindex-2 bg-white mt-lg-56" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "December 1939", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "light lines-3" }, " Whitlam meets his wife-to-be, Margaret Dovey, at the Sydney University Dramatic Society’s Christmas party. ", -1))
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "timelinedot col-12 col-lg-5 col-xl-4 col-xxl-3 offset-xl-2 offset-xxl-4 zindex-2 bg-white" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "8 December 1941", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "light lines-3" }, " The day after the attack on Pearl Harbour, Whitlam registers with the Royal Australian Air Force (RAAF). ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Quote = _resolveComponent("Quote")!
  const _component_Gallery = _resolveComponent("Gallery")!
  const _component_DidYouKnow = _resolveComponent("DidYouKnow")!
  const _component_Impact = _resolveComponent("Impact")!
  const _component_LightboxButton = _resolveComponent("LightboxButton")!
  const _component_PanelLeft = _resolveComponent("PanelLeft")!
  const _component_Reveal = _resolveComponent("Reveal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PanelLeft, {
      pills: ['Education', 'University', 'War'],
      image: "assets/images/04-bg.jpg"
    }, {
      body: _withCtx(() => [
        _hoisted_1
      ]),
      button: _withCtx(() => [
        _createVNode(_component_LightboxButton, {
          dyk: "",
          impact: ""
        }, {
          main: _withCtx(() => [
            _hoisted_2,
            _hoisted_3,
            _hoisted_4,
            _hoisted_5,
            _createVNode(_component_Quote, { class: "w-50 mx-auto" }, {
              author: _withCtx(() => [
                _hoisted_7
              ]),
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(_component_Gallery, { imagery: [
							['5.1-gallery.jpg', 'University of Sydney’s Fisher Library in 1935. Image: National Library of Australia.'],
							['5.2-gallery.jpg', 'Gough Whitlam in 1935, around 19 years of age. Image: Whitlam Prime Ministerial Collection.'],
							['5.3-gallery.jpg', 'Gough Whitlam with his sister, Freda. Image: Whitlam Prime Ministerial Collection.'],
							['5.4-gallery.jpg', 'Gough Whitlam with the St. Paul’s College rowing team, 1937. Image: Whitlam Prime Ministerial Collection.'],
							['5.5-gallery.jpg', 'The University of Sydney in the 1930s. Image: National Library of Australia.'],
							['5.0-gallery.jpg', 'Sydney University. Image: National Library of Australia.'],
						] }, null, 8, ["imagery"]),
            _createVNode(_component_DidYouKnow, null, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_Impact, null, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      _: 3
    }),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("section", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_Reveal, { left: "" }, {
              default: _withCtx(() => [
                _hoisted_14,
                _hoisted_15
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_Reveal, { left: "" }, {
              default: _withCtx(() => [
                _hoisted_18,
                _hoisted_19
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_Reveal, null, {
              default: _withCtx(() => [
                _hoisted_22,
                _hoisted_23
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_Reveal, { left: "" }, {
              default: _withCtx(() => [
                _hoisted_26,
                _hoisted_27
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ], 64))
}